import { render, staticRenderFns } from "./PlayIcon.vue?vue&type=template&id=f0125f72&scoped=true"
import script from "./PlayIcon.vue?vue&type=script&lang=js"
export * from "./PlayIcon.vue?vue&type=script&lang=js"
import style0 from "./PlayIcon.vue?vue&type=style&index=0&id=f0125f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0125f72",
  null
  
)

export default component.exports